export const VALID_PHONE_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/;

export const isValidPhone = (phone: string): boolean => {
  return VALID_PHONE_REGEX.test(phone);
};

export const formatPhoneNumber = (phone: string, { pickEnd = true } = {}) => {
  // Remove any existing formatting
  let cleaned = (phone || '')
    .replace(/^\+1/, '') // Remove leading +1 only if it's at the start
    .replace(/[^0-9]/g, ''); // Remove all non-digit characters

  if (pickEnd) {
    cleaned = cleaned.slice(-10);
  }

  // Otherwise format as before
  return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};
